// DataCenterPage.js
import React, { useEffect } from 'react';
import { Container } from 'react-bootstrap';
import AOS from 'aos';
import 'aos/dist/aos.css';
import StickyHeader from '../../components/StickyHeader';
import StickyFooter from '../../components/StickyFooter';
import '../../css/Home.css';


function DataCenterPage() {
  useEffect(() => {
    // 初始化AOS动画库
    AOS.init({
      duration: 1000,
      once: true,
      offset: 100
    });
  }, []);

  return (
    <div className="home-container">
      <StickyHeader />

      {/* 主要内容区域 */}
      <div className="main-content">
        <div className="stitle" >
          <img
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover"
            }}
            src={`${process.env.PUBLIC_URL}/imgs/7.png`}
            alt=""
          />
          <div style={{
            position: "absolute",
            bottom: "40px",
            left: "40px",
            color: "white",
            textShadow: "0 2px 10px rgba(0, 0, 0, 0.7)",
            maxWidth: "60%"
          }}>
            <h2 style={{
              fontSize: "3.5rem",
              fontWeight: "700",
              marginBottom: "15px",
              letterSpacing: "2px",
              lineHeight: "1.2",
              margin: "0",
              padding: "0"
            }}>
              数据中心解决方案
            </h2>
            <p style={{
              fontSize: "1.3rem",
              lineHeight: "1.6",
              opacity: "0.95",
              margin: "0",
              padding: "0"
            }}>

            </p>
          </div>
        </div>
        <div style={{ minHeight: '800px' }}>
          {/* 第一个盒子 - 方案介绍 */}
          <div className='top12 animated-section'>
            <Container>
              <div className='box'>
                <div className='top'>
                  <div className='noe1' data-aos="fade-down">
                    <span className='h1'>方 案 介 绍</span>
                    <p>
                      <img src={`${process.env.PUBLIC_URL}/imgs/Dot.png`} alt="" className="dot-animation" />
                    </p>
                  </div>
                  <div className='boxno'>
                    <div className='lef' data-aos="fade-right">
                      <h3 className='h3'>
                        方案介绍
                      </h3>
                      <span className='textnoe'>
                        数据中心储能方案通过接入储能系统，为数据中心这一高耗能场景提供高可靠性供电和有效的降本增效途径。其核心价值在于：利用峰谷电价差进行充放电操作，显著降低数据中心的运营成本；同时，储能系统能作为应急备用电源，提升数据中心供电可靠性，确保算力业务不中断。
                      </span>
                    </div>
                    <div className='rit' data-aos="fade-left" data-aos-delay="200">
                      <img src={`${process.env.PUBLIC_URL}/imgs/shuj.png`} alt="" className="image-hover" />
                    </div>
                  </div>
                </div>
              </div>
            </Container>
          </div>

          {/* 第二个盒子 - 系统框图 */}
          <div className='top1 system-section'             >
            <Container>
              <div className='box'>
                <div className='top'>
                  <div className='noe1' data-aos="fade-down">
                    <span className='h1'>系 统 框 图</span>
                    <p>
                      <img src={`${process.env.PUBLIC_URL}/imgs/Dot.png`} alt="" className="dot-animation" />
                    </p>
                  </div>
                  <div className='boxno' data-aos="zoom-in" data-aos-delay="300">
                    <img className='image-kuangsssss'  src={`${process.env.PUBLIC_URL}/imgs/07数据中心系统框图.png`} alt="" />
                  </div>
                </div>
              </div>
            </Container>
          </div>

          {/* 第三个盒子 - 产品优势 */}
          <div className='top2 advantage-section'>
            <Container>
              <div className='box'>
                <div className='top'>
                  <div className='noe1' data-aos="fade-down">
                    <span className='h2'>产 品 优 势</span>
                    <p>
                      <img src={`${process.env.PUBLIC_URL}/imgs/Dot.png`} alt="" className="dot-animation" />
                    </p>
                  </div>
                  <div className='boxno'>
                    {[
                      { img: 'xiao1.png', title: '提高电能', desc: '无功补偿，优化供电质量' },
                      { img: 'xiao2.png', title: '应急备电', desc: '并离网切换，为负载持续供电' },
                      { img: 'xiao3.png', title: '快速投运', desc: '灵活部署，缩短建设周期' },
                      { img: 'xiao4.png', title: '降低成本', desc: '削峰填谷，实现峰谷套利' },
                      { img: 'xiao5.png', title: '高安全性', desc: '液冷系统，全氟己酮电箱消防' },
                      { img: 'xiao6.png', title: '消纳绿电', desc: '减少弃光，提高绿电使用率' },
                      { img: 'xiao7.png', title: '灵活扩容', desc: '实现增容、扩容，支持380V、10kV电网接入' },
                      { img: 'xiao8.png', title: '可扩展性', desc: '可外接设备，扩展直流充电和直流光伏' }
                    ].map((item, index) => (
                      <div
                        key={index}
                        className='boxflex'
                        data-aos="flip-up"
                        data-aos-delay={index * 100}
                      >
                        <div className='flextop'>
                          <img src={`${process.env.PUBLIC_URL}/imgs/${item.img}`} alt="" />
                        </div>
                        <div className='flexbut'>
                          <p>{item.title}</p>
                          <p>{item.desc}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </Container>
          </div>

          {/* 第四个盒子 - 生命周期流程图*/}
          <div className='top12 lifecycle-section' style={{ backgroundColor: '#f8f9fa' }}>
            <Container>
              <div className='box'>
                <div className='top'>
                  <div className='noe1' data-aos="fade-down">
                    <span className='h1'>生 命 周 期 流 程 图</span>
                    <p>
                      <img src={`${process.env.PUBLIC_URL}/imgs/Dot.png`} alt="" className="dot-animation" />
                    </p>
                  </div>
                  <div className='boxno'>
                    <div className='lef' data-aos="fade-right">
                      <h3 className='h32'>
                        储能系统全生命周期服务保障
                      </h3>
                      <span className='textnoe'>
                        依托成熟的产品研发制造能力、精益的储能系统集成能力、专业的团队项目能力，集研发、制造、交付、投资、运营于一体为我们的客户提供一站式、全生命周期工商业储能系统解决方案。
                      </span>
                      <div className='linebut'>
                        {[
                          { img: 'line1.png', text: '产品研发体系' },
                          { img: 'line2.png', text: '专业的储能技术' },
                          { img: 'line3.png', text: '项目团队' }
                        ].map((item, index) => (
                          <div className='linebox' key={index} data-aos="zoom-in" data-aos-delay={index * 200}>
                            <img src={`${process.env.PUBLIC_URL}/imgs/${item.img}`} alt="" />
                            <p>{item.text}</p>
                          </div>
                        ))}
                      </div>
                    </div>
                    <div className='rits' data-aos="fade-left" data-aos-delay="400">
                      <img src={`${process.env.PUBLIC_URL}/imgs/tu4.png`} alt="" className="image-hover" />
                    </div>
                  </div>
                </div>
              </div>
            </Container>
          </div>

          {/* 第五个盒子 - 产品案例 */}
          {/* <div className='top0 case-section'>
            <Container>
              <div className='box'>
                <div className='top'>
                  <div className='noe1' data-aos="fade-down">
                    <span className='h1'>产 品 案 例</span>
                    <p>
                      <img src={`${process.env.PUBLIC_URL}/imgs/Dot.png`} alt="" className="dot-animation" />
                    </p>
                  </div>
                  <div className='boxno'>
                    {[
                      { img: 'zhan1.png', title: '振宜汽车有限公司储能电站项目', specs: ['6.388MW', '13.767MWh'] },
                      { img: 'zhan2.png', title: '安庆福莱克斯动力科技有限公司储能电站项目', specs: ['3.156MW', '6.312MWh'] },
                      { img: 'zhan3.png', title: '安徽益丰塑料包装有限公司储能电站项目', specs: ['250kW', '1075kWh'] }
                    ].map((item, index) => (
                      <div className='sexbut' key={index} data-aos="fade-up" data-aos-delay={index * 150}>
                        <div className='seximg'>
                          <img src={`${process.env.PUBLIC_URL}/imgs/${item.img}`} alt="" />
                        </div>
                        <div className='sextext'>
                          <p className='toptex'>{item.title}</p>
                          <p className='toptexd'>
                            <span>{item.specs[0]}</span>
                            <span>|</span>
                            <span>{item.specs[1]}</span>
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </Container>
          </div> */}

        </div>

      </div>

      <StickyFooter />
    </div>
  );
}

export default DataCenterPage;